// import apiService from "../service/jobService";

// export const fetchJobItems = (date) => async (dispatch) => {
//   dispatch({ type: "FETCH_JOB_ITEMS_REQUEST" });
//   try {
//     const response = await apiService.get(
//       `GetGroupAttendance?date=${date}&serviceNo=3000694&location=ISM`
//     );
//     console.log("API Response Data:", response.data);
//     dispatch({
//       type: "FETCH_JOB_ITEMS_SUCCESS",
//       payload: response.data.attendanceGroupList,
//     });
//   } catch (error) {
//     console.error("Error fetching job items", error);
//     dispatch({ type: "FETCH_JOB_ITEMS_FAILURE" });
//   }
// };

import apiService from "../service/jobService";

export const fetchJobItems = (date, serviceNo, location) => async (dispatch) => {
  dispatch({ type: "FETCH_JOB_ITEMS_REQUEST" });
  try { const response = await apiService.getJob(date, serviceNo, location);
    //console.log("API Response Data:", response.data);
    dispatch({
      type: "FETCH_JOB_ITEMS_SUCCESS",
      payload: response.data.attendanceGroupList,
    });
  } catch (error) {
    console.error("Error fetching job items", error);
    dispatch({ type: "FETCH_JOB_ITEMS_FAILURE" });
  }
};
